import { Link } from "react-router-dom";
import type { Movie } from "@/types/movie";
import { getCategoryName, ratingTone } from "@/utils/movie";

interface MovieCardProps {
  movie: Movie;
  showSummary?: boolean;
}

const ratingClass: Record<string, string> = {
  high: "bg-primary-500 text-foreground-950",
  mid: "bg-secondary-500 text-foreground-950",
  low: "bg-background-300 text-foreground-950",
};

export default function MovieCard({ movie, showSummary = true }: MovieCardProps) {
  return (
    <Link
      to={`/detail/${movie.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200/60 bg-background-100 transition-colors hover:border-primary-400/60"
    >
      <div className="relative w-full overflow-hidden bg-background-200" style={{ aspectRatio: "2 / 3" }}>
        <img
          src={movie.poster}
          alt={`${movie.title}（${movie.year}）电影海报`}
          title={`${movie.title} - 黄色大片 电影资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/10 to-transparent" />
        <span
          className={`absolute right-2.5 top-2.5 rounded-md px-1.5 py-0.5 font-label text-xs font-semibold ${ratingClass[ratingTone(movie.rating)]}`}
        >
          {movie.rating.toFixed(1)}
        </span>
        <div className="absolute bottom-0 left-0 right-0 p-3">
          <div className="flex flex-wrap items-center gap-1.5">
            {movie.genres.slice(0, 2).map((genre) => (
              <span
                key={genre}
                className="rounded-sm bg-background-50/70 px-1.5 py-0.5 text-[11px] text-foreground-100 backdrop-blur-sm"
              >
                {getCategoryName(genre)}
              </span>
            ))}
            <span className="text-[11px] text-foreground-200">{movie.year}</span>
          </div>
        </div>
      </div>
      <div className="flex flex-1 flex-col p-3.5">
        <h3 className="line-clamp-1 font-heading text-base font-bold text-foreground-50 transition-colors group-hover:text-primary-400">
          {movie.title}
        </h3>
        {showSummary && (
          <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-400">{movie.summary}</p>
        )}
        <div className="mt-auto flex items-center gap-1.5 pt-3 text-xs text-foreground-500">
          <i className="ri-price-tag-3-line text-sm text-primary-400" />
          <span className="line-clamp-1">{movie.tags.slice(0, 2).join(" · ")}</span>
        </div>
      </div>
    </Link>
  );
}